import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#3395FF',
    padding: '2px 8px',
    borderRadius: '4px',
    fontSize: '13px',
    fontWeight: 700,
    color: '#FFFFFF',
    lineHeight: '16px',
  },
});

export default useStyles;
